import QAChecklistPage from "components/olitask/qa-tests/QAChecklistPage";
import React, { Children } from "react";
import App from "App";
import paths, { rootPaths } from "./paths";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";

import AuthSimpleLayout from "../layouts/AuthSimpleLayout";
import UserAffiliations from "components/olitask/users/affiliations/UserAffiliations";
import MainLayout from "../layouts/MainLayout";
import ErrorLayout from "../layouts/ErrorLayout";
import Calendar from "components/app/calendar/Calendar";
// import UserDetails from 'components/app/e-commerce/users/UserDetails';
import Tasks from "components/olitask/tasks";
import TaskDetailsPage from "components/olitask/tasks/TaskDetails";
import Users from "components/olitask/users";
import GuestSessions from "components/olitask/users/GuestSessions";
import Chat from "components/app/chat/Chat";
import { QRCodeGenerator } from "components/olitask/qrcodes";
import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";

import SimpleLogin from "components/authentication/simple/Login";
import SimpleLogout from "components/authentication/simple/Logout";
import SimpleRegistration from "components/authentication/simple/Registration";
import SimpleForgetPassword from "components/authentication/simple/ForgetPassword";
import SimpleVerificationCode from "components/authentication/simple/VerificationCode";
import SimplePasswordReset from "components/authentication/simple/PasswordReset";
import SimpleAccountRecoverySuccess from "components/authentication/simple/AccountRecoverySuccess";
import SessionExpired from "components/authentication/simple/SessionExpired";
import CardLogin from "components/authentication/card/Login";
import CardLogout from "components/authentication/card/Logout";
import CardRegistration from "components/authentication/card/Registration";
import CardForgetPassword from "components/authentication/card/ForgetPassword";
import CardConfirmMail from "components/authentication/card/ConfirmMail";
import CardPasswordReset from "components/authentication/card/PasswordReset";
import CardLockScreen from "components/authentication/card/LockScreen";
import Dashboard from "components/dashboards";
import Analytics from "components/analytics";
import VerticalNavLayout from "layouts/VerticalNavLayout";
import TopNavLayout from "layouts/TopNavLayout";
import ComboNavLayout from "layouts/ComboNavLayout";
import DoubleTopNavLayout from "layouts/DoubleTopNavLayout";
import UserAgreements from "components/general/userAgreements";
import UserAgreementForm from "components/general/userAgreements/form";
import UserAgreementDetails from "components/general/userAgreements/details";
import ActiveAgreement from "components/general/userAgreements/activeAgreement";
import { ApiKeys } from "components/general/apiKeys";
import { ClientIDs } from "components/general/clientIDs";
import UserDetails from "components/olitask/users/UserDetails";
import HelperProfilePage from "components/olitask/users/HelperProfilePage";
import UserIdentityDocuments from "components/olitask/users/IdentityDocuments";
import { DonationsDashboard } from "components/olitask/donations/dashboard";
import { DonationsPuporses } from "components/olitask/donations/purposes";
import UserFormPage from "components/olitask/users/UserFormPage";
import Profile from "components/pages/user/profile/Profile";
import ProfileReviewsPage from "components/olitask/users/ProfileReviewsPage";
import Reviews from "components/olitask/tasks/taskReviews";
import { DonationsTable } from "components/olitask/donations/donationstable";
import { DonationDetails } from "components/olitask/donations/donationstable/DonationDetails";
import GuestDonationsTable from "components/olitask/donations/guest/DonationsTable";
import GuestDonationDetails from "components/olitask/donations/guest/DonationDetails";
import { CreditsTable } from "components/olitask/donations/credits";
import { CreditDetails } from "components/olitask/donations/credits/CreditDetails";
import { DonorDonations } from "components/olitask/donations/donationstable/DonorDonations";
import { IssueCreditPage } from "components/olitask/donations/credits/IssueCreditPage";
import { CreditApplications } from "components/olitask/donations/credit_applications";
import { ApplicationDetails } from "components/olitask/donations/credit_applications/ApplicationDetails";
import { IssueApplicationCredit } from "components/olitask/donations/credit_applications/IssueApplicationCredit";

//account management components
import SecurityQnsTable from "components/accountManagement/SecurityQns";
import PasswordReset from "components/accountManagement/AccountRecovery/passwordReset";
import AccountSecurityQuestions from "components/accountManagement/AccountRecovery";
import CreateNewPassword from "components/accountManagement/AccountRecovery/resetPassword";
import ChangePassword from "components/accountManagement/changePassword";
import RolesManagement from "components/access-control/roles";
import PrivilegeManagement from "components/access-control/privileges";
import AssignRole from "components/access-control/assign-role";
import RoleDetails from "components/access-control/roles/RoleDetails";
import AppConfigPage from "components/access-control/app-config";
import LocationRestrictionsPage from "components/access-control/location-restrictions/LocationRestrictionsPage";
import Guard from "components/access-control/rbac/Guard";
import Unauthorised from "components/access-control/rbac/Unauthorised";
import { PRIV } from "components/access-control/rbac/privileges";
import TaskCategories from "components/olitask/tasks/categories/TaskCategories";
import Feedbacks from "components/olitask/feedbacks";
import AppVersions from "components/olitask/app-versions";
import SubscriptionsManagementPage from "components/access-control/subscriptions";
import QaTestRunsPage from "components/olitask/qa-tests";
import QaTestFeaturesPage from "components/olitask/qa-tests/FeaturesPage";
import QaTestAppHistoryPage from "components/olitask/qa-tests/AppHistoryPage";
import QaTestFeatureHistoryPage from "components/olitask/qa-tests/FeatureHistoryPage";
import {
  CancellationPolicyActivePage,
  CancellationPolicyHistoryPage,
} from "components/olitask/cancellation-policy";
import RoutesPage from "components/general/route-rules/RoutesPage";
import Projects from "components/olitask/projects";
import ProjectsProvider from "providers/ProjectsProvider";
import ProjectFormPage from "components/olitask/projects/pages/ProjectFormPage";
import TaskFormPage from "components/olitask/projects/pages/TaskFormPage";
import MessageTemplates from "components/accountManagement/message-templates";
import MessageTemplateView from "components/accountManagement/message-templates/MessageTemplateView";
import CreateMessageTemplate from "components/accountManagement/message-templates/CreateMessageTemplate";
import EditMessageTemplate from "components/accountManagement/message-templates/EditMessageTemplate";
import {
  ComposeEmailPage,
  SentEmailsPage,
  ViewSentEmailPage,
} from "components/accountManagement/emails";
import InhouseEmails from "components/olitask/inhouse-emails/emails";
import ComposeInhouseEmailPage from "components/olitask/inhouse-emails/emails/ComposeInhouseEmailPage";
import EmailAccounts from "components/olitask/inhouse-emails/emailaccounts";
import { Tags } from "components/general/tags";
import { Airports } from "components/olitask/airports";
import TravelTaskCategories from "components/olitask/airline/travel-categories";
import MeetingPoints from "components/olitask/airline/meeting-points";
import ProjectDetails from "components/olitask/projects/pages/ProjectDetails";
import IterationDetails from "components/olitask/projects/pages/IterationDetails";
import HealthChecks from "components/systemMonitoring/health-checks";
import FeatureDials from "components/systemMonitoring/feature-dial";
import PMDashboard from "components/olitask/projects/pages/PMDashboard";
import TaskDetailPage from "components/olitask/projects/pages/TaskDetailPage";
import UserActionablesPage from "components/olitask/users/actionables/UserActionablesPage";
import ChargesConfigPage from "components/finance/charges/ChargesConfigPage";
import UserDeletionRequests from "components/olitask/userdeletion";
import ExternalAccountsPage from "components/finance/payments/ExternalAccountsPage";
import PaymentTransactionsPage from "components/finance/payments/PaymentTransactionsPage";
import RefundHistoryPage from "components/finance/payments/RefundHistoryPage";
import PayoutTransactionsPage from "components/finance/payouts/PayoutTransactionsPage";
import PayoutChargesPage from "components/finance/payouts/PayoutChargesPage";
import NotificationTopicsPage from "components/accountManagement/notificationTopics/NotificationTopicsPage";
import ApplicationsPage from "components/access-control/applications/ApplicationsPage";
import HelpRequestsPage from "components/olitask/help-requests/HelpRequestsPage";
import DashboardProvider from "providers/DashboardProvider";
import RateLimitEventsPage from "components/general/rateLimitEvents/RateLimitEventsPage";
import TaskCounterOffers from "components/olitask/tasks/TaskCounterOffers";
import TaskProgressPingsPage from "components/olitask/tasks/TaskProgressPings";
import HelperRequestsPage from "components/olitask/users/helpers/HelperRequestsPage";
import HelperProfessionProfilesRedirectPage from "components/olitask/helper-professions/HelperProfessionProfilesRedirectPage";
import HelperProfessionProfileDetailsPage from "components/olitask/helper-professions/HelperProfessionProfileDetailsPage";
import HelperProfessionProfileFormPage from "components/olitask/helper-professions/HelperProfessionProfileFormPage";
import BackgroundChecksPage from "components/olitask/helper-professions/background-checks/BackgroundChecksPage";
import BackgroundCheckDetailsPage from "components/olitask/helper-professions/background-checks/BackgroundCheckDetailsPage";
import BusinessEntitiesPage from "components/profile/business/entities/BusinessEntitiesPage";
import BusinessEntityDetailsPage from "components/profile/business/entities/BusinessEntityDetailsPage";
import ServiceOfferingsPage from "components/profile/business/services/ServiceOfferingsPage";
import AttachServicePage from "components/profile/business/services/AttachServicePage";
const routes = [
  {
    element: <App />,
    children: [
      {
        path: rootPaths.errorsRoot,
        element: <ErrorLayout />,
        children: [
          {
            path: paths.error404,
            element: <Error404 />,
          },
          {
            path: paths.error500,
            element: <Error500 />,
          },
        ],
      },
      {
        path: paths.qaChecklist,
        element: <QAChecklistPage />,
      },
      {
        path: rootPaths.authRoot,
        children: [
          {
            path: rootPaths.authSimpleRoot,
            element: <AuthSimpleLayout />,
            children: [
              {
                path: paths.simpleLogin,
                element: (
                  <PublicRoute>
                    <SimpleLogin />
                  </PublicRoute>
                ),
              },
              {
                path: paths.simpleRegister,
                element: (
                  <PublicRoute>
                    <SimpleRegistration />
                  </PublicRoute>
                ),
              },
              {
                path: paths.simpleLogout,
                element: <SimpleLogout />,
              },
              {
                path: paths.simpleSessionExpired,
                element: <SessionExpired />,
              },
              {
                path: paths.simpleForgotPassword,
                element: <PasswordReset />,
              },

              {
                path: paths.simpleVerificationCode,
                element: <SimpleVerificationCode />,
              },
              {
                path: paths.simpleResetPassword,
                element: <SimplePasswordReset />,
              },
              {
                path: paths.simpleAccountRecoverySuccess,
                element: <SimpleAccountRecoverySuccess />,
              },
            ],
          },
          {
            path: rootPaths.authSplitRoot,
            children: [
              {
                path: paths.splitForgotPassword,
                element: <AccountSecurityQuestions />,
              },
              {
                path: paths.splitResetPassword,
                element: <CreateNewPassword />,
              },
            ],
          },

          {
            path: rootPaths.authCardRoot,
            children: [
              {
                path: paths.cardLogin,
                element: (
                  <PublicRoute>
                    <CardLogin />
                  </PublicRoute>
                ),
              },
              {
                path: paths.cardRegister,
                element: (
                  <PublicRoute>
                    <CardRegistration />
                  </PublicRoute>
                ),
              },
              {
                path: paths.cardLogout,
                element: <CardLogout />,
              },
              {
                path: paths.cardForgotPassword,
                element: <CardForgetPassword />,
              },
              {
                path: paths.cardResetPassword,
                element: <CardPasswordReset />,
              },
              {
                path: paths.cardConfirmMail,
                element: <CardConfirmMail />,
              },
              {
                path: paths.cardLockScreen,
                element: <CardLockScreen />,
              },
            ],
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <ProjectsProvider>
              <MainLayout />
            </ProjectsProvider>
          </ProtectedRoute>
        ),
        children: [
	          {
	            index: true,
	            element: (
	              <DashboardProvider>
	                <Dashboard />
	              </DashboardProvider>
	            ),
	          },
	          {
	            path: paths.analytics,
	            element: (
	              <DashboardProvider scope="analytics">
	                <Analytics />
	              </DashboardProvider>
	            ),
	          },

          // olitask components
          {
            path: rootPaths.olitaskRoot,
            children: [
              {
                path: paths.users,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <Navigate to={paths.customers} replace />
                  </Guard>
                ),
              },
              {
                path: paths.customers,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <Users staff={false} />
                  </Guard>
                ),
              },
              {
                path: paths.staff,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <Users staff={true} />
                  </Guard>
                ),
              },
       
              {
                path: paths.userAffiliations,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserAffiliations />
                  </Guard>
                ),
              },
              {
                path: paths.userDeletionRequests,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserDeletionRequests />
                  </Guard>
                ),
              },
              {
                path: paths.guestSessions,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <GuestSessions />
                  </Guard>
                ),
              },
              {
                path: paths.userAdd,
                element: (
                  <Guard
                    privilege={PRIV.CREATE_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserFormPage />
                  </Guard>
                ),
              },
              {
                path: paths.userDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserDetails />
                  </Guard>
                ),
              },

              {
                path: paths.userEdit(),
                element: (
                  <Guard
                    privilege={PRIV.UPDATE_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserFormPage />
                  </Guard>
                ),
              },
              {
                path: paths.reviewsTaskReviews(),
                element: <Reviews />,
              },
              {
                path: paths.profileReviews(),
                element: <ProfileReviewsPage />,
              },

              {
                path: paths.identityDocuments(),
                element: (
                  <Guard
                    privilege={PRIV.VERIFY_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserIdentityDocuments />
                  </Guard>
                ),
              },
              {
                path: paths.userHelperProfile(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <HelperProfilePage />
                  </Guard>
                ),
              },
              {
                path: paths.helperRequests,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <HelperRequestsPage />
                  </Guard>
                ),
              },
              {
                path: paths.helperProfessionProfiles,
                element: (
                  <Guard privilege={PRIV.VIEW_USERS} fallback={<Unauthorised />}>
                    <HelperProfessionProfilesRedirectPage />
                  </Guard>
                ),
              },
              {
                path: paths.helperProfessionBackgroundChecks,
                element: (
                  <Guard privilege={PRIV.VIEW_USERS} fallback={<Unauthorised />}>
                    <BackgroundChecksPage />
                  </Guard>
                ),
              },
              {
                path: paths.helperProfessionBackgroundCheckDetails(),
                element: (
                  <Guard privilege={PRIV.VIEW_USERS} fallback={<Unauthorised />}>
                    <BackgroundCheckDetailsPage />
                  </Guard>
                ),
              },
              {
                path: paths.helperProfessionProfileDetails(),
                element: (
                  <Guard privilege={PRIV.VIEW_USERS} fallback={<Unauthorised />}>
                    <HelperProfessionProfileDetailsPage />
                  </Guard>
                ),
              },
              {
                path: paths.helperProfessionProfileCreateForHelper(),
                element: (
                  <Guard privilege={PRIV.VIEW_USERS} fallback={<Unauthorised />}>
                    <HelperProfessionProfileFormPage />
                  </Guard>
                ),
              },
              {
                path: paths.helperProfessionProfileEditForHelper(),
                element: (
                  <Guard privilege={PRIV.VIEW_USERS} fallback={<Unauthorised />}>
                    <HelperProfessionProfileFormPage />
                  </Guard>
                ),
              },
              {
                path: paths.userActionables(),
                element: (
                  <Guard
                    privilege={PRIV.VERIFY_USERS}
                    fallback={<Unauthorised />}
                  >
                    <UserActionablesPage />
                  </Guard>
                ),
              },
              {
                path: paths.airports,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <Airports />
                  </Guard>
                ),
              },
              {
                path: paths.travelCategories,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <TravelTaskCategories />
                  </Guard>
                ),
              },
              {
                path: paths.meetingPoints,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_USERS}
                    fallback={<Unauthorised />}
                  >
                    <MeetingPoints />
                  </Guard>
                ),
              },
              {
                path: paths.taskCategories,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TASKS}
                    fallback={<Unauthorised />}
                  >
                    <TaskCategories />
                  </Guard>
                ),
              },
              {
                path: paths.tasks,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TASKS}
                    fallback={<Unauthorised />}
                  >
                    <Tasks />
                  </Guard>
                ),
              },
              {
                path: paths.taskDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TASKS}
                    fallback={<Unauthorised />}
                  >
                    <TaskDetailsPage />
                  </Guard>
                ),
              },
              {
                path: paths.taskCounterOffers(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TASKS}
                    fallback={<Unauthorised />}
                  >
                    <TaskCounterOffers />
                  </Guard>
                ),
              },
              {
                path: paths.taskProgressPings(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TASKS}
                    fallback={<Unauthorised />}
                  >
                    <TaskProgressPingsPage />
                  </Guard>
                ),
              },
              {
                path: paths.QRCodeGenerator,
                element: <QRCodeGenerator />,
              },
              {
                path: paths.donationsList,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_DONATIONS}
                    fallback={<Unauthorised />}
                  >
                    <DonationsTable />
                  </Guard>
                ),
              },
              {
                path: paths.guestDonations,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_DONATIONS}
                    fallback={<Unauthorised />}
                  >
                    <GuestDonationsTable />
                  </Guard>
                ),
              },
              {
                path: paths.donationDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_DONATIONS}
                    fallback={<Unauthorised />}
                  >
                    <DonationDetails />
                  </Guard>
                ),
              },
              {
                path: paths.guestDonations + "/:id",
                element: (
                  <Guard
                    privilege={PRIV.VIEW_DONATIONS}
                    fallback={<Unauthorised />}
                  >
                    <GuestDonationDetails />
                  </Guard>
                ),
              },
              {
                path: paths.donorDonations(),
                element: <DonorDonations />,
              },
              {
                path: paths.donationsPurposes,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PURPOSES}
                    fallback={<Unauthorised />}
                  >
                    <DonationsPuporses />
                  </Guard>
                ),
              },
              {
                path: paths.donationsCredit,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_CREDITS}
                    fallback={<Unauthorised />}
                  >
                    <CreditsTable />
                  </Guard>
                ),
              },
              {
                path: paths.creditDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_CREDITS}
                    fallback={<Unauthorised />}
                  >
                    <CreditDetails />
                  </Guard>
                ),
              },
              {
                path: paths.creditApplications,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPLICATIONS}
                    fallback={<Unauthorised />}
                  >
                    <CreditApplications />
                  </Guard>
                ),
              },
              {
                path: paths.applicationDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPLICATIONS}
                    fallback={<Unauthorised />}
                  >
                    <ApplicationDetails />
                  </Guard>
                ),
              },
              {
                path: paths.issueCredit(),
                element: (
                  <Guard
                    privilege={PRIV.ISSUE_CREDIT}
                    fallback={<Unauthorised />}
                  >
                    <IssueCreditPage />
                  </Guard>
                ),
              },
              {
                path: paths.issueCreditFromApplication(),
                element: (
                  <Guard
                    privilege={PRIV.ISSUE_CREDIT}
                    fallback={<Unauthorised />}
                  >
                    <IssueApplicationCredit />
                  </Guard>
                ),
              },
              {
                path: paths.feedBacks,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_FEEDBACKS}
                    fallback={<Unauthorised />}
                  >
                    <Feedbacks />
                  </Guard>
                ),
              },
              {
                path: paths.helpRequests,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_FEEDBACKS}
                    fallback={<Unauthorised />}
                  >
                    <HelpRequestsPage />
                  </Guard>
                ),
              },
              {
                path: paths.appVersions,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPVERSIONS}
                    fallback={<Unauthorised />}
                  >
                    <AppVersions />
                  </Guard>
                ),
              },
              {
                path: paths.subscriptions,
                element: <SubscriptionsManagementPage />,
              },
              {
                path: paths.qaTestRuns,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPVERSIONS}
                    fallback={<Unauthorised />}
                  >
                    <QaTestRunsPage />
                  </Guard>
                ),
              },
              {
                path: paths.qaTestRunsFeatures(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPVERSIONS}
                    fallback={<Unauthorised />}
                  >
                    <QaTestFeaturesPage />
                  </Guard>
                ),
              },
              {
                path: paths.qaTestRunsAppHistory(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPVERSIONS}
                    fallback={<Unauthorised />}
                  >
                    <QaTestAppHistoryPage />
                  </Guard>
                ),
              },
              {
                path: paths.qaTestRunsFeatureHistory(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APPVERSIONS}
                    fallback={<Unauthorised />}
                  >
                    <QaTestFeatureHistoryPage />
                  </Guard>
                ),
              },
              {
                path: paths.cancellationPolicyRules,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_FEEDBACKS}
                    fallback={<Unauthorised />}
                  >
                    <Navigate to={paths.cancellationPolicyActive} replace />
                  </Guard>
                ),
              },
              {
                path: paths.cancellationPolicyActive,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_FEEDBACKS}
                    fallback={<Unauthorised />}
                  >
                    <CancellationPolicyActivePage />
                  </Guard>
                ),
              },
              {
                path: paths.cancellationPolicyHistory,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_FEEDBACKS}
                    fallback={<Unauthorised />}
                  >
                    <CancellationPolicyHistoryPage />
                  </Guard>
                ),
              },
            ],
          },
          //account management components
          {
            path: rootPaths.accountRoot,
            children: [
              {
                path: paths.securityQuestions,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_SECURITY_QUESTIONS}
                    fallback={<Unauthorised />}
                  >
                    <SecurityQnsTable />
                  </Guard>
                ),
              },
              {
                path: paths.messageTemplates,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TEMPLATES}
                    fallback={<Unauthorised />}
                  >
                    <MessageTemplates />
                  </Guard>
                ),
              },
              {
                path: paths.messageTemplateDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_TEMPLATES}
                    fallback={<Unauthorised />}
                  >
                    <MessageTemplateView />
                  </Guard>
                ),
              },
              {
                path: paths.createMessageTemplate,
                element: (
                  <Guard
                    privilege={PRIV.CREATE_TEMPLATES}
                    fallback={<Unauthorised />}
                  >
                    <CreateMessageTemplate />
                  </Guard>
                ),
              },
              {
                path: paths.editMessageTemplate(),
                element: (
                  <Guard
                    privilege={PRIV.UPDATE_TEMPLATES}
                    fallback={<Unauthorised />}
                  >
                    <EditMessageTemplate />
                  </Guard>
                ),
              },
              {
                path: paths.notificationTopics,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_NOTIFICATION_TOPICS}
                    fallback={<Unauthorised />}
                  >
                    <NotificationTopicsPage />
                  </Guard>
                ),
              },
              {
                path: paths.passwordReset,
                element: <PasswordReset />,
              },
              {
                path: paths.createNewPassword,
                element: <CreateNewPassword />,
              },
              {
                path: paths.accountSecurityQns,
                element: <AccountSecurityQuestions />,
              },
              {
                path: paths.changePassword,
                element: <ChangePassword />,
              },
            ],
          },

          // access control components
          {
            path: rootPaths.accessControlRoot,
            children: [
              {
                path: paths.manageApps,
                element: (
                  <Guard
                    privilege={PRIV.MANAGE_APPLICATIONS}
                    fallback={<Unauthorised />}
                  >
                    <ApplicationsPage />
                  </Guard>
                ),
              },
              {
                path: paths.roles,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_ROLES}
                    fallback={<Unauthorised />}
                  >
                    <RolesManagement />
                  </Guard>
                ),
              },
              {
                path: paths.roleDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_ROLES}
                    fallback={<Unauthorised />}
                  >
                    <RoleDetails />
                  </Guard>
                ),
              },
              {
                path: paths.privileges,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PRIVILEGES}
                    fallback={<Unauthorised />}
                  >
                    <PrivilegeManagement />
                  </Guard>
                ),
              },
              {
                path: paths.assignRole,
                element: (
                  <Guard
                    privilege={PRIV.ASSIGN_ROLES}
                    fallback={<Unauthorised />}
                  >
                    <AssignRole />
                  </Guard>
                ),
              },
              {
                path: paths.routeRules,
                element: (
                  <Guard
                    privilege={PRIV.MANAGE_APIS}
                    fallback={<Unauthorised />}
                  >
                    <RoutesPage />
                  </Guard>
                ),
              },
              {
                path: paths.apiKeys,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_APIKEYS}
                    fallback={<Unauthorised />}
                  >
                    <ApiKeys />
                  </Guard>
                ),
              },
              {
                path: paths.clientIds,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_CLIENTIDS}
                    fallback={<Unauthorised />}
                  >
                    <ClientIDs />
                  </Guard>
                ),
              },
              {
                path: paths.clientIdDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_CLIENTIDS}
                    fallback={<Unauthorised />}
                  >
                    <ClientIDs />
                  </Guard>
                ),
              },
              {
                path: paths.rateLimitEvents,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_RATE_LIMITS}
                    fallback={<Unauthorised />}
                  >
                    <RateLimitEventsPage />
                  </Guard>
                ),
              },
              {
                path: paths.appConfig,
                element: (
                  <Guard
                    privilege={PRIV.MANAGE_APIS}
                    fallback={<Unauthorised />}
                  >
                    <AppConfigPage />
                  </Guard>
                ),
              },
              {
                path: paths.locationRestrictions,
                element: (
                  <Guard
                    privileges={[
                      PRIV.MANAGE_APIS,
                      PRIV.MANAGE_LOCATION_RESTRICTIONS,
                    ]}
                    fallback={<Unauthorised />}
                  >
                    <LocationRestrictionsPage />
                  </Guard>
                ),
              },
            ],
          },

          // general components
          {
            path: rootPaths.userRoot,
            children: [
              {
                path: paths.userProfile,
                element: <Profile />,
              },
            ],
          },

          {
            path: rootPaths.monitoringRoot,
            children: [
              {
                path: paths.healthChecks,
                element: (
                  <Guard
                    privileges={[
                      PRIV.MANAGE_HEALTH_CHECKS,
                      PRIV.VIEW_HEALTH_CHECKS,
                    ]}
                    fallback={<Unauthorised />}
                  >
                    <HealthChecks />
                  </Guard>
                ),
              },
              {
                path: paths.healthCheckAdd,
                element: (
                  <Guard
                    privileges={[
                      PRIV.MANAGE_HEALTH_CHECKS,
                      PRIV.CREATE_HEALTH_CHECKS,
                    ]}
                    fallback={<Unauthorised />}
                  >
                    <HealthChecks />
                  </Guard>
                ),
              },
              {
                path: paths.healthCheckDetail(),
                element: (
                  <Guard
                    privileges={[
                      PRIV.MANAGE_HEALTH_CHECKS,
                      PRIV.VIEW_HEALTH_CHECKS,
                    ]}
                    fallback={<Unauthorised />}
                  >
                    <HealthChecks />
                  </Guard>
                ),
              },

              // feature dial ,
              {
                path: paths.featureDial,
                element: (
                  <Guard
                    privileges={[
                      PRIV.MANAGE_FEATURE_DIALS, // Can manage feature dials
                      PRIV.VIEW_FEATURE_DIAL, // Can view feature dials
                    ]}
                    fallback={<Unauthorised />}
                  >
                    <FeatureDials />
                  </Guard>
                ),
              },
              {
                path: paths.featureDialAdd,
                element: (
                  <Guard
                    privileges={[
                      PRIV.MANAGE_FEATURE_DIALS, // Can manage feature dials
                      PRIV.UPDATE_FEATURE_DIAL, // Or CREATE_FEATURE_DIAL if you have it
                    ]}
                    fallback={<Unauthorised />}
                  >
                    <FeatureDials />
                  </Guard>
                ),
              },
              {
                path: paths.featureDialDetail(),
                element: (
                  <Guard
                    privileges={[
                      PRIV.MANAGE_FEATURE_DIALS, // Can manage feature dials
                      PRIV.VIEW_FEATURE_DIAL, // Can view details
                    ]}
                    fallback={<Unauthorised />}
                  >
                    <FeatureDials />
                  </Guard>
                ),
              },
            ],
          },

          {
            path: rootPaths.generalRoot,
            children: [
              {
                path: paths.agreements,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_AGREEMENTS}
                    fallback={<Unauthorised />}
                  >
                    <UserAgreements />
                  </Guard>
                ),
              },
              {
                path: paths.agreementAdd,
                element: (
                  <Guard
                    privilege={PRIV.ADD_AGREEMENTS}
                    fallback={<Unauthorised />}
                  >
                    <UserAgreementForm />
                  </Guard>
                ),
              },
              {
                path: paths.agreementEdit(),
                element: (
                  <Guard
                    privilege={PRIV.EDIT_AGREEMENTS}
                    fallback={<Unauthorised />}
                  >
                    <UserAgreementForm />
                  </Guard>
                ),
              },
              {
                path: paths.agreementDetails(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_AGREEMENTS}
                    fallback={<Unauthorised />}
                  >
                    <UserAgreementDetails />
                  </Guard>
                ),
              },
              {
                path: paths.activeAgreement,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_ACTIVE_AGREEMENT}
                    fallback={<Unauthorised />}
                  >
                    <ActiveAgreement />
                  </Guard>
                ),
              },
              {
                path: paths.projectEdit(),
                element: <ProjectFormPage />,
              },
              {
                path: paths.projectTaskAdd(),
                element: <TaskFormPage />,
              },
              {
                path: paths.projectTaskEdit(),
                element: <TaskFormPage />,
              },
              {
                path: paths.projectTaskDetails(),
                element: <TaskDetailPage />,
              },
              {
                path: paths.projectIterationDetails(),
                element: <IterationDetails />,
              },
              {
                path: paths.projectIterations(),
                element: <Projects />,
              },
              {
                path: paths.projectDetails(),
                element: <ProjectDetails />,
              },
              {
                path: paths.projectAdd,
                element: <ProjectFormPage />,
              },
              {
                path: paths.projects,
                element: <Projects />,
              },
              {
                path: paths.pmDashboard,
                element: <PMDashboard />,
              },
              {
                path: paths.Tags,
                element: <Tags />,
              },
              {
                path: paths.emailCompose,
                element: <ComposeEmailPage />,
              },
              {
                path: paths.emailIncoming,
                element: <InhouseEmails defaultTab="incoming" />,
              },
              {
                path: paths.emailOutgoing,
                element: <InhouseEmails defaultTab="outgoing" />,
              },
              {
                path: paths.emailAccounts,
                element: <EmailAccounts />,
              },
              {
                path: paths.emailInhouseCompose,
                element: <ComposeInhouseEmailPage />,
              },
              {
                path: paths.emailSent,
                element: <SentEmailsPage />,
              },
              {
                path: paths.emailSentDetail(),
                element: <ViewSentEmailPage />,
              },
            ],
          },

          // profile (business module)
          {
            path: rootPaths.profileRoot,
            children: [
              {
                path: paths.businessEntities,
                element: (
                  <Guard
                    privilege={PRIV.UPDATE_PROFILE}
                    fallback={<Unauthorised />}
                  >
                    <BusinessEntitiesPage />
                  </Guard>
                ),
              },
              {
                path: paths.businessEntityDetails(),
                element: (
                  <Guard
                    privilege={PRIV.UPDATE_PROFILE}
                    fallback={<Unauthorised />}
                  >
                    <BusinessEntityDetailsPage />
                  </Guard>
                ),
              },
              {
                path: paths.serviceOfferings,
                element: (
                  <Guard
                    privilege={PRIV.UPDATE_PROFILE}
                    fallback={<Unauthorised />}
                  >
                    <ServiceOfferingsPage />
                  </Guard>
                ),
              },
              {
                path: paths.attachServiceOffering(),
                element: (
                  <Guard
                    privilege={PRIV.UPDATE_PROFILE}
                    fallback={<Unauthorised />}
                  >
                    <AttachServicePage />
                  </Guard>
                ),
              },
            ],
          },

          // finance components
          {
            path: rootPaths.financeRoot,
            children: [
              {
                path: paths.paymentCharges,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_CHARGES}
                    fallback={<Unauthorised />}
                  >
                    <ChargesConfigPage />
                  </Guard>
                ),
              },
              {
                path: paths.externalAccounts,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PAYOUTS}
                    fallback={<Unauthorised />}
                  >
                    <ExternalAccountsPage />
                  </Guard>
                ),
              },
              {
                path: paths.payouts,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PAYOUTS}
                    fallback={<Unauthorised />}
                  >
                    <PayoutTransactionsPage />
                  </Guard>
                ),
              },
              {
                path: paths.payoutCharges,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PAYOUTS}
                    fallback={<Unauthorised />}
                  >
                    <PayoutChargesPage />
                  </Guard>
                ),
              },
              {
                path: paths.paymentTransactions,
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PAYOUTS}
                    fallback={<Unauthorised />}
                  >
                    <PaymentTransactionsPage />
                  </Guard>
                ),
              },
              {
                path: paths.paymentRefundHistory(),
                element: (
                  <Guard
                    privilege={PRIV.VIEW_PAYOUTS}
                    fallback={<Unauthorised />}
                  >
                    <RefundHistoryPage />
                  </Guard>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <VerticalNavLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: paths.verticalNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <TopNavLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: paths.topNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <ComboNavLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: paths.comboNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "/",
        element: (
          <ProtectedRoute>
            <DoubleTopNavLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: paths.doubleTopNavLayout,
            element: <Dashboard />,
          },
        ],
      },
      {
        path: "*",
        element: <Navigate to={paths.error404} replace />,
      },
    ],
  },
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL,
});

export default routes;
